import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import GroupFilterItemView from './GroupFilterItemView';

class SelectedGroupFilterView extends Component {

    handleChange = (keyName) => {
        var group = this.props.search && this.props.search.group;
        this.props.handleChange({groupSelected: {category: group, keyName: keyName}});
    }

    renderItems() {
        var group = this.props.search && this.props.search.group;
        if (!group) {
            return;
        }

        var attributeSelected = this.props.attributeSelected || [];
        var data = attributeSelected.map(function(item, index) {
            return <GroupFilterItemView facets={this.props.facets}
                search={this.props.search}
                attributeSelected={this.props.attributeSelected}
                group={item.category}
                ellipsis={true}
                key={`${index}-${item.category}`}
                handleChange={this.handleChange}
                keyName={item.keyName}/>;
        }, this);
        if (data.length > 0) {
            data.push(<button className="group-cell-item group-selected no-style-link-button"
                key={'clear'}
                onClick={this.props.handleClearAll}>Clear All</button>);
        }
        return data;
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="form-group">
                    {this.renderItems()}
                </Col>
            </Row>
        );
    }
}

export default SelectedGroupFilterView;

